import { createSelector } from 'reselect';

import { IIntState } from '../../../../modules/internationalization/intReducer';
import { selectInt } from '../../../../modules/internationalization/intSelectors';
import { personalDataApi } from './store';

/*
* -------------------------------------------
*               Translation
* -------------------------------------------
*/

export const personalDataTranslationSelector = () =>
    createSelector(
        selectInt,
        (state: IIntState) => state.translation.pageSubscriberId.tabs.personalData,
    );

/*
* -------------------------------------------
*               Api
* -------------------------------------------
*/

// meta

const personalDataApiSelector = (subscriberId: string) =>
    personalDataApi.endpoints.getPersonalDataMeta.select(subscriberId);

export const personalDataDocTypesSelector = (subscriberId: string) => createSelector(
    personalDataApiSelector(subscriberId),
    meta => meta?.data?.docTypes ?? {},
);

export const personalDataPassportIdSelector = (subscriberId: string) => createSelector(
    personalDataApiSelector(subscriberId),
    meta => meta?.data?.passportId,
);

export const personalDataOptionsSelector = (subscriberId: string) => createSelector(
    personalDataApiSelector(subscriberId),
    meta => meta?.data?.options ?? [],
);

export const personalDataMaxFileAmountSelector = (subscriberId: string) => createSelector(
    personalDataApiSelector(subscriberId),
    meta => meta?.data?.maxFileAmount ?? 0,
);

export const personalDataMaxFileSizeSelector = (subscriberId: string) => createSelector(
    personalDataApiSelector(subscriberId),
    meta => meta?.data?.maxFileSize,
);

export const personalDataDocumentAttributesSelector = (subscriberId: string) => createSelector(
    personalDataApiSelector(subscriberId),
    meta => meta?.data?.personalDataTypes?.documentAttributes ?? [],
);

export const personalDataMandatoryAttributesSelector = (subscriberId: string) => createSelector(
    personalDataApiSelector(subscriberId),
    meta => meta?.data?.personalDataTypes?.mandatoryAttributes ?? [],
);
